export default class AddToCartComponent extends HTMLElement {
  constructor() {
    super();

    // bindings
    this.onClickQtyDecrease = this.onClickQtyDecrease.bind(this);
    this.onClickQtyIncrease = this.onClickQtyIncrease.bind(this);
    this.onClickBuyAsGiftOpt =  this.onClickBuyAsGiftOpt.bind(this);
    this.onClickAddToCart = this.onClickAddToCart.bind(this);
    this.onSubmitBisForm = this.onSubmitBisForm.bind(this);
    this.onClickCustomizerBtn = this.onClickCustomizerBtn.bind(this);
    this.onCustomizerInputChange = this.onCustomizerInputChange.bind(this);
    this.onGiftTextareaChange = this.onGiftTextareaChange.bind(this);

    // privates
    this._node = this;

    this._quantity_btn = this._node.querySelectorAll(".quantity-btn");
    this._quantity = 1;

    this._buy_as_gift_opt = this._node.querySelector(".buy-as-gift-opt");
    if (this._buy_as_gift_opt) {
      this._gift_message_wrapper = this._node.querySelector(".gift-message-wrapper");
      this._gift_textarea = this._gift_message_wrapper.querySelector("textarea");
      this._gift_message_count = this._gift_message_wrapper.querySelector(".message-count");
    }

    this._add_to_cart_btn = this._node.querySelector(".atc-btn");
    this._quick_add = this._add_to_cart_btn && this._add_to_cart_btn.classList.contains("quick") ? true : false;
    this._pinned_atc_bar = this._node.querySelector(".pinned-atc-bar");
    this._pinned_atc_btn = this._node.querySelector('.pinned-atc-btn');
    this._pinned_title = this._node.querySelector('.pinned-title');
    this._pinned_thumb = this._node.querySelectorAll('.pinned-thumb');
    this._add_to_cart_error = this._node.querySelector(".atc-error");

    this._customizer_btn = this._node.querySelector('.customizer-btn');
    this._customizer_preview_wrapper = this._node.querySelector('.customizer-preview-wrapper');
    this._customizer_preview_text = document.getElementById('svg-label-text');
    this._customizer_input = this._node.querySelector('input[name="customizer"]');
    this._customizer_id = '';
    this._customizer_price = 0;
    this._customizer_enabled = false;

    if (!this._quick_add && this._pinned_atc_bar) {
      document.body.classList.add('--pb');
      this.pinnedBarState();
    }

    this._bis_form = this._node.querySelector('.bis-form');
    this._bis_sending = false;

    if (this._bis_form) {
      this._bis_btn = this._node.querySelector('.bis-btn');
      this._bis_kid = this._bis_form.getAttribute('data-kid');
      this._bis_pid = parseInt(this._bis_form.getAttribute('data-pid'), 10);
      this._bis_vid = parseInt(this._bis_form.getAttribute('data-vid'), 10);
      this._bis_input = this._bis_form.querySelector('input');
      this._bis_message = this._node.querySelector('.bis-message');
    }

    this._cart_drawer = document.getElementById('cart-drawer');
    this._drawer_scroll = this._cart_drawer.querySelector('.cart-items');

    this._cart_btn = document.getElementById("cart-btn");

    // Simplified PDP
    this._base_price = this._node.getAttribute('data-base-price');
    this._base_discount = this._node.hasAttribute('data-discount') ? this._node.getAttribute('data-discount') : false;

    if (this._base_discount) {
      this.updateButtonPrice(this._base_price, this._base_discount);
    }

    // events
    if (this._quantity_btn.length > 0) {
      this._available_qty = this._quantity_btn[0].getAttribute('data-available') ? parseInt(this._quantity_btn[0].getAttribute('data-available'), 10) : false;
      this._qty_minus = this._node.querySelectorAll(".qty-minus");
      this._qty_count = this._node.querySelectorAll(".qty-count");
      this._qty_plus = this._node.querySelectorAll(".qty-plus");

      this._qty_minus.forEach((el) => {
        el.addEventListener('click', this.onClickQtyDecrease);
      });

      this._qty_plus.forEach((el) => {
        el.addEventListener('click', this.onClickQtyIncrease);
      });
    }

    if (this._customizer_btn && this._customizer_input) {
      this._customizer_price = this._customizer_input.getAttribute('data-customizer-price');
      this._customizer_id = parseInt(this._customizer_input.getAttribute('data-customizer-id'), 10);
      this._customizer_max_chars = parseInt(this._customizer_input.getAttribute('maxlength'), 10);

      this._customizer_btn.addEventListener('click', this.onClickCustomizerBtn);
      this._customizer_input.addEventListener('input', this.onCustomizerInputChange);
    }

    if (this._buy_as_gift_opt) {
      this._buy_as_gift_opt.addEventListener('click', this.onClickBuyAsGiftOpt);
      this._gift_textarea.addEventListener('input', this.onGiftTextareaChange);
      this.onGiftTextareaChange();
    }

    if (this._add_to_cart_btn) {
      let max = this._add_to_cart_btn.getAttribute('data-max') ? parseInt(this._add_to_cart_btn.getAttribute('data-max'), 10) : 10;
      this._max_qty = max > 10 ? 10 : max;
      this._id = parseInt(this._add_to_cart_btn.getAttribute("data-id"), 10);
      this._add_to_cart_btn.addEventListener('click', this.onClickAddToCart);

      if (this._pinned_atc_btn) {
        this._pinned_atc_btn.addEventListener('click', this.onClickAddToCart);
      }
    }

    if (this._bis_form) {
      this._bis_form.addEventListener('submit', this.onSubmitBisForm);
    }
  }

  pinnedBarState() {
    let observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) {
        this._pinned_atc_bar.classList.add('--show');
      } else {
        this._pinned_atc_bar.classList.remove('--show');
      }
    });

    observer.observe(this._add_to_cart_btn);
  }

  onClickCustomizerBtn() {
    if (this._customizer_btn.classList.contains('--open')) {
      this._customizer_btn.classList.remove('--open');
      this._customizer_preview_wrapper.classList.remove('--expanded');
    } else {
      this._customizer_btn.classList.add('--open');
      this._customizer_preview_wrapper.classList.add('--expanded');
    }
  }

  onCustomizerInputChange() {
    let val = this._customizer_input.value.trim().replace(/[^\w\s]+/gi, '');
    this._customizer_input.value = val;
    this._customizer_preview_text.textContent = val;

    let discount = this._base_discount ? this._base_discount : false,
        price = this._base_discount ? this._base_discount : this._base_price;

    if (this._customizer_input.value === '') {
      this._customizer_btn.classList.remove('--active');
      this._customizer_input.classList.remove('--has-value');
      this._customizer_enabled = false;
    } else {
      this._customizer_btn.classList.add('--active');
      this._customizer_input.classList.add('--has-value');
      this._customizer_enabled = true;
      price = `$${parseInt(price.replace('$', ''), 10) + parseInt(this._customizer_price.replace('$', ''), 10)}`;
    }

    this.updateButtonPrice(price, discount);
  }

  updateButtonPrice(price, discount_price) {
    let label = this._node.hasAttribute('data-btn-label') ? this._node.getAttribute('data-btn-label') : 'Add to Cart',
        prices = discount_price ? `<span class="compare strikeout">${price}</span> ${discount_price}` : price;

    if (this._add_to_cart_btn) {
      this._add_to_cart_btn.innerHTML = `<span>${label}</span><span>${prices}</span>`;
    }

    if (this._pinned_atc_btn) {
      this._pinned_atc_btn.innerHTML = `<span>${label}</span><span>${prices}</span>`;
    }
  }

  onClickQtyDecrease() {
    if (this._available_qty) {
      this._quantity = Math.max((this._quantity - 1), 1);

      this._qty_count.forEach((el) => {
        el.innerText = this._quantity;
      });

      if (this._quantity < this._available_qty && this._quantity < this._max_qty) {
        this._qty_plus.forEach((el) => {
          el.classList.remove('--disabled');
        });
      }
    }
  }

  onClickQtyIncrease() {
    this._qty_plus.forEach((el) => {
      el.classList.remove('--disabled');
    });

    if (this._available_qty) {
      this._quantity = Math.min((this._quantity + 1), 10);
      this._qty_count.forEach((el) => {
        el.innerText = this._quantity;
      });

      if (this._quantity >= this._available_qty || this._quantity === this._max_qty) {
        this._qty_plus.forEach((el) => {
          el.classList.add('--disabled');
        });
      }
    }
  }

  onClickBuyAsGiftOpt(e) {
    if (!this._buy_as_gift_opt.classList.contains('--selected')) {
      this._buy_as_gift_opt.classList.add('--selected');
      this._buy_as_gift_opt.setAttribute('aria-checked', true);

      this._gift_message_wrapper.classList.add('--expand');
      this._gift_message_wrapper.setAttribute('aria-expanded', true);
    } else {
      this._buy_as_gift_opt.classList.remove('--selected');
      this._buy_as_gift_opt.setAttribute('aria-checked', false);

      this._gift_message_wrapper.classList.remove('--expand');
      this._gift_message_wrapper.setAttribute('aria-expanded', false);

      this._gift_textarea.value = '';
    }
  }

  onGiftTextareaChange(e) {
    let val = this._gift_textarea.value.trim(),
        max_count = 250;

    if (val.length > max_count) {
      this._gift_message_count.classList.add('--max');
      this._gift_textarea.value = this._gift_textarea.value.trimStart().substring(0, max_count);
    } else {
      this._gift_message_count.classList.remove('--max');
    }

    this._gift_message_count.innerHTML = `(${this._gift_textarea.value.trim().length} / ${max_count})`;
  }

  onClickAddToCart() {
    let items = [],
        refill_id = this._node.hasAttribute('data-rid') ? parseInt(this._node.getAttribute('data-rid'), 10) : false,
        selling_plan_id = this._node.hasAttribute('data-pid') ? parseInt(this._node.getAttribute('data-pid'), 10) : false,
        add_rod = refill_id && selling_plan_id ? true : false,
        product_data = { id: this._id, quantity: this._quantity },
        customizer_value = this._customizer_enabled && this._customizer_input.value.trim().length > 0 ? this._customizer_input.value.trim().substring(0, this._customizer_max_chars) : false,
        customizer_prop_name = this._customizer_enabled ? this._customizer_input.getAttribute('data-prop-name') : '',
        product_customizer_data = false;

    this.updateProductError();
    this._add_to_cart_btn.classList.add('--sending');
    if (this._pinned_atc_btn) {
      this._pinned_atc_btn.classList.add('--sending');
    }

    if (this._gift_textarea) {
      let message_value = this._gift_textarea.value.trim(),
          message = message_value === "" ? false : message_value;

      if (message) {
        console.log('add message to cart');
        if (product_data.properties) {
          product_data.properties["Message"] = message;
        } else {
          product_data.properties = {
            "Message": message
          }
        }
      }
    }

    if (this._customizer_enabled && customizer_value) {
      let now = Date.now();
      product_customizer_data = { id: this._customizer_id, quantity: 1 };
      product_customizer_data.properties = {
        [customizer_prop_name]: customizer_value,
        '_uniq': `${this._customizer_id}:${now}`
      }
      // make unique data
      if (product_data.properties) {
        product_data.properties['_uniq'] = `${this._customizer_id}:${now}`;
      } else {
        product_data.properties = {
          '_uniq': `${this._customizer_id}:${now}`
        }
      }
    }

    if (add_rod) {
      // Order of pushed items matters for cart drawer flow...
      // First add ROD, THEN the base product
      items.push({ id: refill_id, quantity: 1, selling_plan: selling_plan_id });
      if (customizer_value && product_customizer_data) {
        items.push(product_customizer_data);
      }
      items.push(product_data);
      this.getCart(items, refill_id);
    } else {
      if (customizer_value && product_customizer_data) {
        items.push(product_customizer_data);
      }
      items.push(product_data);
      this.getCart(items);
    }
  }

  async getCart(items, refill_id) {
    const cart_res = await fetch("/cart.js");
    const cart_json = await cart_res.json();
    let cart_items = cart_json.items;

    if (cart_items.length > 0) {
      let cef = false;
      cart_items.forEach((item) => {
        if (item.properties && item.properties['Refill Code']) {
          cef = true;
        }
      });

      if (cef) {
        this.emptyCart(items);
      } else {
        let cart_item_ids = cart_items.map((item) => item.id),
            item_ids = items.map((item) => item.id),
            limit_reached = false;

        // Check if we hit max qty allowed...
        cart_items.forEach((item) => {
          if (item.id !== refill_id && item_ids.indexOf(item.id) !== -1) {
            if (item.quantity >= this._max_qty) {
              limit_reached = true;
            }
          }
        });

        if (limit_reached) {
          let error = "You’ve reached the maximum quantity allowed for this product";
          this.updateProductError(error);
        } else {
          // Check if ROD already exists before adding a duplicate...
          let add_items = [];

          if (items.length > 1) {
            if (cart_item_ids.indexOf(refill_id) === -1) {
              add_items.push(items[0]);
            }

            items.forEach((item, index) => {
              if (index > 0) {
                add_items.push(item);
              }
            });
          } else {
            add_items.push(items[0]);
          }

          if (add_items.length > 0) {
            this.addToCart(add_items);
          } else {
            // Do nothing, reset... (edge case)
            this.updateProductError();
          }
        }
      }
    } else {
      this.addToCart(items);
    }
  }

  emptyCart(items) {
    fetch("/cart/clear.js", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then((response) => {
      if (!response.ok) {
        console.log(response);
      } else {
        return response.json();
      }
    })
    .then((response) => {
      if (response) {
        this.addToCart(items);
      }
    })
  }

  async addToCart(items) {
    fetch("/cart/add.js", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({items})
    })
    .then((response) => {
      if (!response.ok) {
        console.log(response);
        let error = "An error occured! Please try again later.";

        // if (response.status === 422) {
        //   error = "Not enough items in stock. Try adding a lower quantity."
        // }

        this.updateProductError(error);
      } else {
        return response.json();
      }
    })
    .then((response) => {
      if (response) {
        this.updateCartDrawer();
      }
    })
  }

  async updateCartDrawer() {
    const cart_res = await fetch("/cart.js");
    const cart = await cart_res.json();
    this.updateCartCount(cart.item_count);

    const drawer_res = await fetch("/?section_id=cart-drawer");
    const text = await drawer_res.text();
    const html = document.createElement("div");
    html.innerHTML = text;
    const template = html.querySelector(".cart-drawer-box").innerHTML;

    document.querySelector(".cart-drawer-box").innerHTML = template;
    this.updateProductError();
    this.openCartDrawer();
  }

  updateCartCount(item_count) {
    let count = this._cart_btn.querySelector('.count');

    if (item_count > 0) {
      this._cart_btn.classList.remove('--empty');
    } else {
      this._cart_btn.classList.add('--empty');
    }

    count.innerText = item_count;
  }

  updateProductError(error) {
    if (this._add_to_cart_btn) {
      this._add_to_cart_btn.classList.remove('--sending');
    }

    if (this._pinned_atc_btn) {
      this._pinned_atc_btn.classList.remove('--sending');
    }

    if (error) {
      this._add_to_cart_error.innerHTML = `<p>${error}</p>`;
      this._add_to_cart_error.style.display = "block";

      let event_horizon = window.pageYOffset,
          destination = this._node.getBoundingClientRect().top + event_horizon - 96;

      if (Math.round(destination) !== Math.round(event_horizon)) {
        window.scroll({
          top: destination,
          left: 0,
          behavior: 'smooth'
        });
      }
    } else {
      this._add_to_cart_error.innerHTML = "";
      this._add_to_cart_error.style.display = "none";
    }
  }

  openCartDrawer() {
    this._cart_drawer.classList.add('--open-drawer');
    this._drawer_scroll.scrollTop = 0;
    document.body.style.overflow = 'hidden';

    let cart_title = document.getElementById('cart-title');
    if (cart_title) {
      cart_title.setAttribute('tabindex', '-1');
      setTimeout(() => {
        cart_title.focus();
      }, 0);
    }
  }

  onSubmitBisForm(e) {
    e.preventDefault();

    if (this._bis_sending) {
      return false;
    }

    this._bis_sending = true;
    this._bis_btn.classList.add('--sending');
    this._bis_message.innerText = '';
    this._bis_message.classList.remove('error');
    document.activeElement.blur();

    const email = this._bis_input.value.trim();
    const variantId = `$shopify:::$default:::${this._bis_vid}`;
    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email
              }
            }
          },
          channels: ['EMAIL']
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: variantId
            }
          }
        }
      }
    };

    fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(this._bis_kid)}`, {
      headers: {
        'accept': 'application/json',
        'content-type': 'application/json',
        'revision': '2024-06-15'
      },
      body: JSON.stringify(payload),
      method: 'POST'
    })
    .then(async (response) => {
      let message = "An error occured. Please try again later.";
      let responseJson = null;

      if (response.status !== 202) {
        try {
          responseJson = await response.json();
        } catch (error) {
          responseJson = null;
        }
      }

      if (response.status === 202) {
        message = "Thanks! We'll email you as soon as this size becomes available again.";
        this._bis_input.value = '';
      } else {
        this._bis_message.classList.add('error');

        const apiError = responseJson && responseJson.errors && responseJson.errors[0] && responseJson.errors[0].detail;
        if (apiError) {
          message = apiError;
        } else if (response.status === 400) {
          message = "API request is missing or invalid. Please try again later.";
        } else if (response.status === 404) {
          message = "This product variant could not be found. Please try again later.";
        }
      }

      this._bis_btn.classList.remove('--sending');
      this._bis_message.innerText = message;
      this._bis_sending = false;
    })
    .catch((err) => {
      console.error('BIS ERROR:', err)
      this._bis_btn.classList.remove('--sending');
      this._bis_message.innerText = "An error occured. Please try again later.";
      this._bis_message.classList.add('error');
      this._bis_sending = false;
    })
  }

  /**
   * Handle unmount.
   */
   disconnectedCallback() {
     if (this._quantity_btn.length > 0) {
       this._qty_minus.forEach((el) => {
         el.removeEventListener('click', this.onClickQtyDecrease);
       });

       this._qty_plus.forEach((el) => {
         el.removeEventListener('click', this.onClickQtyIncrease);
       });
     }

     if (this._customizer_btn) {
       this.onClickCustomizerBtn.removeEventListener('click', this.onClickCustomizerBtn);
       this._customizer_input.removeEventListener('input', this.onCustomizerInputChange);
     }

     if (this._buy_as_gift_opt) {
       this._buy_as_gift_opt.removeEventListener('click', this.onClickBuyAsGiftOpt);
       this._gift_textarea.removeEventListener('input', this.onGiftTextareaChange);
     }

     if (this._add_to_cart_btn) {
       this._add_to_cart_btn.removeEventListener('click', this.onClickAddToCart);
     }

     if (this._pinned_atc_btn) {
       this._pinned_atc_btn.removeEventListener('click', this.onClickAddToCart);
     }

     if (this._bis_form) {
       this._bis_form.removeEventListener('submit', this.onSubmitBisForm);
     }
  }
}
